import { memo, useEffect, useState } from 'react';
import { MenuBuilder } from 'app/layout/Menu/models/MenuBuilder';
import { useAuth } from 'auth/hooks/useAuth';
import { MENU_ITEMS } from 'app/layout/Menu/menu-items';
import { AppMenu } from './AppMenu/AppMenu';
import { AppMenuContentProps } from './models/MenuContentProps';

export const Menu = memo(() => {
  const [menu, setMenu] = useState<AppMenuContentProps[]>([]);
  const { user } = useAuth();

  useEffect(() => {
    const menu = new MenuBuilder()
      .addItems(MENU_ITEMS)
      .filterUserPermisions(user.funcionalidades)
      .build();
    setMenu(menu);
  }, [user]);

  return <AppMenu menu={menu} showBrand={true} fullHeight={true} />;
});
